import { ORIGINAL, ORIGINAL_TRANSLATION_ID } from '@/pages/translation/constants';
import { ITranslation, LibraryItem, TranslationStatus } from '@d-id/types';

export const getIdToTranslationMap = ({
    idToTranslation,
    libraryItem,
    originalTranslationId,
}: {
    idToTranslation: Record<string, ITranslation>;
    libraryItem: LibraryItem;
    originalTranslationId: string;
}): Record<string, ITranslation> => {
    const allowedStatuses: TranslationStatus[] = [
        TranslationStatus.Started,
        TranslationStatus.Validating,
        TranslationStatus.Created,
        TranslationStatus.Ready,
        TranslationStatus.Done,
    ];

    const originalTranslation: Record<string, ITranslation> = {
        [originalTranslationId]: {
            id: originalTranslationId,
            name: `${libraryItem.name}-${ORIGINAL}`,
            language: ORIGINAL,
            status: TranslationStatus.Done,
            result_url: libraryItem.video_url ?? '',
            source_url: libraryItem.video_url ?? '',
            subtitles_url: libraryItem.subtitles_url,
            subtitles: !!libraryItem.subtitles_url,
            created_at: libraryItem.created_at,
            owner_id: libraryItem.created_by ?? '',
            thumbnail_url: libraryItem.thumbnail_url,
            modified_at: libraryItem.created_at,
            created_by: libraryItem.created_by ?? '',
            group_id: libraryItem.id,
            locale: ORIGINAL,
        },
    };

    return Object.entries(idToTranslation)
        .filter(([_, translation]) => allowedStatuses.includes(translation.status))
        .reduce((acc, [id, translation]) => {
            acc[id] = translation;
            return acc;
        }, originalTranslation);
};

export const getFailedTranslationsLanguages = (idToTranslation: Record<string, ITranslation>): string[] => {
    return Object.entries(idToTranslation)
        .filter(([_, translation]) => [TranslationStatus.Error, TranslationStatus.Rejected].includes(translation.status))
        .map(([_, translation]) => translation.language || '');
};

export const translationsArrayIntoObject = (translations: ITranslation[] = []): Record<string, ITranslation> => {
    return translations.reduce(
        (acc, translation) => {
            acc[translation.id] = translation;
            return acc;
        },
        {} as Record<string, ITranslation>
    );
};

export const isOriginalTranslation = (id?: string): boolean => !!id && id.startsWith(ORIGINAL_TRANSLATION_ID);
